// JavaScript для features-list
import { onReady } from '../base/init.js';

onReady(function () {
  // Код для features-list
});
